import { useHistory, useLocation } from "react-router-dom";
import { brandModelActions } from "../../../../context/actions/brandModelActions";
import useStore from "../../../../context/useStore";
import { useEffect } from "react";
import { brandActions } from "../../../../context/actions/brandActions";
import tools from "../../../../helpers/tools";
import { atom, useAtom } from "jotai";

export const repurchaseSearchAtom = atom({
  search: "",
  brandModel: "",
  brand: "",
  fuel_types: [],
  actif: 1,
});

const useRepurchaseSearch = ({ handlePageParamsChange }) => {
  const [state, dispatch] = useStore();
  const brand_actions = brandActions(state, dispatch);
  const brand_model_actions = brandModelActions(state, dispatch);
  const location = useLocation();
  const history = useHistory();

  const [repurchaseSearch, setRepurchaseSearch] = useAtom(repurchaseSearchAtom);

  useEffect(() => {
    brand_actions.getAllBrands();
    brand_model_actions.getAllBrandModels();
  }, []);

  const actions = {
    onTriggerSearch: (params) => {
      handlePageParamsChange(params);
      tools.updateQueryParams(history, location, params);
    },

    onSubmit: (e) => {
      e.preventDefault();
      actions.onTriggerSearch(repurchaseSearch);
    },

    onResetSearch: () => {
      const newSearchParams = {
        search: "",
        brand: "",
        brandModel: "",
        fuel_types: [],
        actif: 1,
      };
      setRepurchaseSearch(newSearchParams);
      actions.onTriggerSearch(newSearchParams);
    },

    onChangeSearch: (e) => {
      const { name, value } = e.target;
      const next = { ...repurchaseSearch, [name]: value, page: "1" };

      // Sélection d'un modèle → auto-sélectionne sa marque
      if (name === "brandModel" && value) {
        const bm = (state.brandModel.items || []).find(
          (m) => m.uuid === value
        );
        if (bm?.brand?.uuid && bm.brand.uuid !== repurchaseSearch.brand) {
          next.brand = bm.brand.uuid;
        }
      }

      // Changement de marque → reset le modèle s'il n'appartient pas à la nouvelle marque
      if (name === "brand" && repurchaseSearch.brandModel) {
        const currentBm = (state.brandModel.items || []).find(
          (m) => m.uuid === repurchaseSearch.brandModel
        );
        if (!value || currentBm?.brand?.uuid !== value) {
          next.brandModel = "";
        }
      }

      setRepurchaseSearch(next);
    },

    onToggleAfficherDesactivees: (showDeactivated) => {
      setRepurchaseSearch({
        ...repurchaseSearch,
        actif: showDeactivated ? null : 1,
        page: "1",
      });
    },

    onToggleFuelType: (fuelTypeId) => {
      const currentFuelTypes = repurchaseSearch.fuel_types || [];
      const isSelected = currentFuelTypes.some((id) => id == fuelTypeId);
      const newFuelTypes = isSelected
        ? currentFuelTypes.filter((id) => id != fuelTypeId)
        : [...currentFuelTypes, fuelTypeId];
      setRepurchaseSearch({
        ...repurchaseSearch,
        fuel_types: newFuelTypes,
        page: "1",
      });
    },
  };

  return {
    state,
    repurchaseSearch,
    actions,
  };
};

export default useRepurchaseSearch;
